import React, { Suspense, lazy } from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import AppRouter from "./routes/AppRouter";

const PWAInstallPrompt = lazy(() => import("./Components/PWA/PWAInstallPrompt"));
const ServiceWorkerUpdateToast = lazy(() => import("./Components/PWA/ServiceWorkerUpdateToast"));
const CustomDialog = lazy(() => import("./Components/Shared/CustomDialog"));

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Suspense fallback={null}>
          <PWAInstallPrompt />
          <ServiceWorkerUpdateToast />
          <CustomDialog />
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
